skrilla.controller('betDetailsCtrl', function ($scope, searchService, $stateParams, validationService, modalService, cacheService, sportEventService, betService, racingEventService, adminV2Service) {

    $scope.tabs = [
        {title: "Details", active: true},
        {title: "Event Audits", active: false},
    ];

    $scope.get = function() {
        searchService.get("bets/" + $stateParams.id).then(function (response) {
            $scope.bet = response.data;
            $scope.bet.selections.forEach((it) => {
                it.oddsLong = it.odds * 10000
            })
            $scope.bet.odds = betService.deriveOdds($scope.bet);
        })
    }
    $scope.reject = function(){
        cacheService.registerObject("betDetails", $scope.bet)
        modalService.openModal("views/betDetails/rejectBetModal.html", true, 'lg', true, true, $scope.get);
    }
    $scope.accept = function(){
        modalService.confirm("Are you sure you'd like to accept this bet?", function(){
            searchService.put("bets/" + $scope.bet.id + "/accept", {message: $scope.message}, "Bet successfully accepted").then(function(response){
                $scope.bet.status = "ACCEPTED";
                modalService.dismissAll();
            });
        });
    }

    $scope.cancel = function(){
        cacheService.registerObject("betDetails", $scope.bet)
        modalService.openModal("views/betDetails/cancelBetModal.html", true, 'lg', true, true, $scope.get);
        $scope.get();
    }
    $scope.voidSelection = function(selection, voidSelection){
        cacheService.registerObject("betDetails", $scope.bet)
        cacheService.registerObject("betSelection", selection)
        cacheService.registerObject("voidSelection", voidSelection)
        modalService.openModal("views/betDetails/voidSelectionModal.html", true, 'lg', true, true, $scope.get);
    }

    $scope.canCancel = function(bet){
        return bet && !['CANCELLED', 'VOID', 'REJECTED'].includes(bet.status);
    }

    $scope.canUnCancel = function(bet){
        return bet && ['VOID'].includes(bet.status);
    }

    $scope.canAccept = function(bet){
        return bet && ['CREATED'].includes(bet.status);
    }
    $scope.canReject = function(bet){
        return bet && ['CREATED'].includes(bet.status);
    }
    $scope.canSettle = function(bet){
        return bet && ['LIVE', 'ACCEPTED'].includes(bet.status);
    }
    $scope.settle = function(){
        modalService.confirm("Are you sure you'd like to settle this bet?", function(){
            searchService.put("bets/" + $scope.bet.id + "/settle", {}, "Bet successfully settled").then(function(response){
                $scope.get()
                modalService.dismissAll();
            });
        });
    }
    $scope.accept = function(){
        modalService.confirm("Are you sure you'd like to accept this bet?", function(){
            searchService.put("bets/" + $scope.bet.id + "/accept", {}, "Bet successfully settled").then(function(response){
                $scope.get()
                modalService.dismissAll();
            });
        });
    }

    $scope.canVoidSelection = function(selection){
        const bet = $scope.bet;
        return $scope.hasRole('editContest') && !selection.void && bet.selections.length > 1 && bet.status !== 'REJECTED';
    }

    $scope.canUnvoidSelection = function(selection){
        const bet = $scope.bet;
        return $scope.hasRole('editContest') && selection.void && bet.status !== 'REJECTED';
    }

    $scope.isRacingEvent = racingEventService.isRacingEvent

    $scope.openV2 = function (id) {
        adminV2Service.openV2(`/racing/races/${id}`)
    }

    $scope.eventUrl = sportEventService.sportEventUrl;

    $scope.get()
});
